module.exports = __webpack_public_path__ + "static/media/plus-circle.c0f2d604.svg";